import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import BIRService from "api/BIRService";
import { useEffect, useMemo, useState } from "react";
import { IGUSCompany } from "dto/IGUSCompany";
import { isValidNip } from "utils/IsValidNip";
import { useDebounce } from "use-debounce";
import { useTranslation } from "react-i18next";

const SearchByNip: FC<Props> = ({
  isError = "",
  defaultValue,
  onDataChange,
  onChange,
  onBlur,
}) => {
  const { t } = useTranslation();
  const [nip, setNip] = useState(defaultValue ?? "");
  const [debouncedNip] = useDebounce(nip, 300);
  const { data, refetch } = BIRService.useGetCompanyFromNIP(
    debouncedNip.replaceAll(" ", "")
  );

  const company: IGUSCompany = useMemo(
    () => (data?.data as IGUSCompany) ?? [],
    [data]
  );

  // Dane z GUS trafiają do formularza dopiero po „Szukaj” w tym polu. Bez tego wynik z pamięci
  // podręcznej (ten sam NIP szukany wcześniej) nadpisywał formularz już przy otwarciu edycji.
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    if (!searched || !company?.Name?.length) return;
    onDataChange(company);
  }, [company, searched]);

  const handleSearch = () => {
    if (isValidNip(nip)) {
      setSearched(true);
      refetch();
    }
  };

  return (
    <div className={styles.wrapper}>
      <Input
        focus
        isNip
        onBlur={onBlur}
        isError={isError}
        onChange={(t) => {
          setNip(t);
          onChange(t);
        }}
        value={nip}
        label={t("forms.nip")}
        placeholder="NIP"
        onRightClick={handleSearch}
        onRightText={t("common.search")}
      />
    </div>
  );
};

export default SearchByNip;
